

import React from "react";
import { FiThumbsDown, FiThumbsUp } from "react-icons/fi";

export const Thumbs = ({id, likes, dislikes}) => {
    const [like] = React.useState(true)
    const [dislike] = React.useState(false);
    return (
        <div className="thumbs">
            <div ><FiThumbsUp className={`${like ? 'up': ''}`} /> {likes}</div>
            <div ><FiThumbsDown className={`${dislike ? 'down': ''}`} /> {dislikes}</div>
        </div>
    )
}
